const pageNameKey = "ticketList";

export const ticketListEn = {
  [pageNameKey]: {
    tabsAll: "All",
    tabsUnassigned: "Unassigned",
    tabsMyTickets: "My Tickets",
    tabsSolved: "Solved",
  },
};

export const ticketListPtBr = {
  [pageNameKey]: {
    tabsAll: "Todos",
    tabsUnassigned: "Não atribuído",
    tabsMyTickets: "Meus tickets",
    tabsSolved: "Resolvidos",
  },
};

export const ticketListDe = {
  [pageNameKey]: {
    tabsAll: "Alle",
    tabsUnassigned: "Nicht zugewiesen",
    tabsMyTickets: "Meine Tickets",
    tabsSolved: "Gelöst",
  },
};

export const ticketListZhHans = {
  [pageNameKey]: {
    tabsAll: "全部",
    tabsUnassigned: "未分配",
    tabsMyTickets: "我的工单",
    tabsSolved: "已解决",
  },
};

export const ticketListIt = {
  [pageNameKey]: {
    tabsAll: "Tutti",
    tabsUnassigned: "Non assegnato",
    tabsMyTickets: "I miei ticket",
    tabsSolved: "Risolti",
  },
};

export const ticketListEs = {
  [pageNameKey]: {
    tabsAll: "Todo",
    tabsUnassigned: "Sin asignar",
    tabsMyTickets: "Mis tickets",
    tabsSolved: "Resueltoss",
  },
};

export const ticketListNl = {
  [pageNameKey]: {
    tabsAll: "Alle",
    tabsMyTickets: "Mijn tickets",
    tabsSolved: "Opgelost",
    tabsUnassigned: "Niet toegewezen",
  },
};

export const ticketListTr = {
  [pageNameKey]: {
    tabsAll: "Tüm",
    tabsMyTickets: "Biletlerim",
    tabsSolved: "Çözüldü",
    tabsUnassigned: "Atanmamış",
  },
};
